import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to get URL search parameters
 * @returns URLSearchParams object for current location
 */
export function useQuery(): URLSearchParams {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default useQuery;
